export enum PaymentProviders {
    Redepagos = 'Redepagos',
    BankTransfer = 'BankTransfer',
    Cash = 'Cash',
    CVUTransfer = 'CVUTransfer',
}
